import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import _ from "lodash";
import { getPortabilityList } from "../../methods/Methods";
import { Card, Col, Typography } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { ResponsePortabilityListData } from "../../types/common";
const { Text } = Typography;

const PortabilityList = () => {
    const generalData = useSelector(getGeneralData);
    const [clientId, setClientId] = useState<string>("");
    const [listPortabilities, setListPortabilities] = useState<ResponsePortabilityListData[]>([]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setClientId(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);


    const getData = useCallback(async () => {
        await getPortabilityList(clientId)
            .then((response) => {
                if (response.data.data[0].success) {
                    setListPortabilities(response.data.data[0].data)
                }
            })
            .catch(() => { })
    }, [clientId]);

    useEffect(() => {
        if (clientId && !_.isEmpty(clientId)) {
            getData();
        }
    }, [clientId, getData]);

    return (
        <>
            {
                listPortabilities.length > 0 &&
                <>
                    <Col span={24} style={{ display: "flex", justifyContent: 'center', margin: 20 }}>
                        <Text style={styles.textTitle}>
                            {"Historial de números porteados"}
                        </Text>
                    </Col>
                    <Card style={styles.card}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={{ ...styles.titleTable, borderTopLeftRadius: 25, borderBottomLeftRadius: 25 }}>
                                        {"Celular"}
                                    </th>
                                    <th style={styles.titleTable}>
                                        {"Estatus"}
                                    </th>
                                    <th style={styles.titleTable}>
                                        {"Fecha de solicitud"}
                                    </th>
                                    <th style={{ ...styles.titleTable, borderTopRightRadius: 25, borderBottomRightRadius: 25 }}>
                                        {"Fecha de ejecución"}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    listPortabilities.map((element: ResponsePortabilityListData, index: any) => (
                                        <tr key={index} style={styles.tableDataRow}>
                                            <td style={styles.textCellphone}>
                                                {element.cellphone}
                                            </td>
                                            <td
                                                style={
                                                    element.status_short === "Exitosa" ? styles.textStatusSuccess
                                                        : element.status_short === "Pendiente" ? styles.textStatusPending
                                                            : element.status_short === "Rechazada" ? styles.textStatusRejected
                                                                : styles.textStatus
                                                }
                                            >
                                                {element.status}
                                            </td>
                                            <td style={styles.textRegistrationDate}>
                                                {element.request_registration_date}
                                            </td>
                                            <td style={styles.textExecutionDate}>
                                                {element.execution_date}
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </Card>
                </>
            }
        </>
    )
};

const styles = StyleSheet.create({
    card: {
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        overflow: 'hidden',
    },
    titleTable: {
        backgroundColor: "#0055c2",
        fontSize: 13,
        color: 'white',
        textAlign: "center",
        padding: "5px 10px",
    },
    tableDataRow: {
        borderBottom: "1px solid #000000",
    },
    textStatus: {
        fontSize: 12,
        color: "#646567",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textStatusPending: {
        fontSize: 12,
        color: "#e8b031",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textStatusSuccess: {
        fontSize: 12,
        color: "#0055c2",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textStatusRejected: {
        fontSize: 12,
        color: "#e00614",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textRegistrationDate: {
        fontSize: 12,
        color: "#646567",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textExecutionDate: {
        fontSize: 12,
        color: "#646567",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textCellphone: {
        fontSize: 12,
        textAlign: "center",
        color: "#000000",
        paddingTop: 20,
        paddingBottom: 20
    },
    textTitle: {
        fontFamily: "Montserrat",
        fontSize: "2.4375em",
        fontWeight: 500,
        color: "#0055b9",
        textAlign: "center",
        lineHeight: 1.02
    },
});


export default PortabilityList;